import { Theme } from '@afterpaytouch/core'

const ThemeClass = {
  [Theme.Cash]: 'theme-unicorn',
  [Theme.AP]: 'theme-narwhal',
} as const

export const getThemeClass = (theme: Theme): string => ThemeClass[theme] ?? ThemeClass[Theme.AP]
